<template>
  <div class="w-full h-auto float-left relative down-shadow">
    <div class="w-full flex flex-row items-center gap-10 px-4 float-left tabs noselect">
      <div v-for="tab in tabs" :key="tab.index" class="pb-3">
        <span :class="{ 'selected-span': selected == tab.index }" @click="
          selected = tab.index;
        $emit('update', tab.component);
        ">
          {{ tab.title }}
        </span>
        <div class="selected" v-if="selected == tab.index"></div>
      </div>
    </div>
    <div class="w-full float-left line"></div>
  </div>
</template>

<script>
export default {
  name: "TabsSelector",
  data() {
    return {
      bookingsCount: 0,

      selected: 0,
    };
  },
  computed: {
    tabs() {
      return [
          { index: 0, title: this.$t('place-order.instant_orders'), component: "instant-orders" },
          { index: 1, title: this.$t('place-order.reservations'), component: "reservation-orders" },
        ];

    },
  },
  created() {
    this.$emit("update", this.tabs[0].component);
  },
  methods: {
    setBookingsCount(count) {
      this.bookingsCount = count;
    },
    decreaseCounter() {
      this.bookingsCount--;
    },
    increaseCounter(cnt) {
      this.bookingsCount += cnt;
    },
  },
};
</script>

<style lang="scss" scoped>
.line {
  height: 1px;
  background: #c1c5d8;
  position: absolute;
  bottom: 0;
}

.down-shadow {
  box-shadow: 0 4px 6px -6px#C1C5D8;
}

.tabs {
  div {
    font-size: 14px;
    font-weight: 400;
    position: relative;
    flex-shrink: 0;
    flex-grow: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: #788e98;

    span {
      cursor: pointer;
    }

    .selected-span {
      color: #e10015;
      font-weight: 500;
    }

    .selected {
      position: absolute;
      width: calc(100% + 14px);
      height: 3px;
      background: #e10015;
      color: #e10015;
      border-radius: 99px 99px 0 0;
      bottom: 0;
      z-index: 2;
    }
  }
}

.tabs::-webkit-scrollbar {
  display: none;
}
</style>
